import JPEG from "jpeg-js";
export default function jpeg() {
    return {
        mime: "image/jpeg",
        encode: (bitmap, { quality = 100 } = {}) => JPEG.encode(bitmap, quality).data,
        decode: (data) => JPEG.decode(data),
    };
}
//# sourceMappingURL=index.js.map